import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  purOrdDivisionUpdateSyncSetting: ['settings'],
  purOrdDivisionSyncPurOrd: null,

  purOrdDivisionFetchList: null,
  purOrdDivisionFetchListLoading: ['boolean'],
  purOrdDivisionFetchListSuccess: ['data'],

  purOrdDivisionCreateDivisionMap: ['form'],
  purOrdDivisionUpdateDivisionMap: ['id', 'form'],
  purOrdDivisionDeleteDivisionMap: ['id']
});

export const PurOrdDivisionTypes = Types;
export default Creators;
